<template>
  <div class="product-detail-page">
    <div v-loading="loading">
      <!-- 产品详情头部 -->
      <div class="top_info">
        <!-- 产品基本信息 -->
        <div class="product-info" v-loading="briefLoading">
          <div class="product-gallery">
            <!-- 主图展示 -->
            <div class="main-image">
              <img v-if="briefInfo.images.length" v-lazy="briefInfo.images[currentImageIndex]+ '?x-oss-process=image/resize,w_492'" :alt="briefInfo.name">
              <img v-else src="../../assets/imgError.jpg" :alt="briefInfo.name">
            </div>
          </div>
          <div class="product-rt">
            <template v-if="briefInfo.category && briefInfo.category === 1">
              <biology :brief-info="briefInfo"></biology>
            </template>
            <template v-else>
              <chemistry :brief-info="briefInfo"></chemistry>
            </template>
          </div>
        </div>

      </div>


      <!-- 产品详情内容 -->
      <section class="detail-section">
        <div class="container">
          <!-- 产品详细信息 -->
          <div class="detail-tabs">
            <div class="detail-lf">

              <!-- 内容区域 -->
              <div class="detail-content">
                <template v-for="(products, productIndex) in product">
                  <!-- format 为 1 纯文本-->
                  <div v-if="products.format === '1'" :id="products.id" class="content-section" :ref="'format' + products.id">
                    <div class="detail-content-tit">
                      <h2 class="section-details-title">{{products.name}}</h2>
                    </div>
                    <div class="description-content">
                      <div class="section">
                        <p>{{ products.content }}</p>
                      </div>
                    </div>
                  </div>

                  <!-- format 为 2 表格-->
                  <div :id="products.id" v-if="products.format === '2' && briefInfo.category !== 1"  class="content-section" :ref="'format' + products.id">
                    <div class="detail-content-tit">
                      <h2 class="section-details-title">{{products.name}}</h2>
                    </div>
                    <div class="description-content ">
                      <div class="section">
                        <div class="specs-wrapper">
                          <div class="specs-left" v-for="(item,  index) in products.content" :key="index + item.label">
                            <div class="specs-title">{{ item.label }}</div>
                            <div class="specs-list">
                              <div class="specs-item" v-for="(lxh, index) in item.children" :key="index + lxh.label" v-if="lxh.value">
                                <span class="label">{{ lxh.label }}</span>
                                <span class="value">{{ lxh.value }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div :id="products.id" v-if="products.format === '2' && briefInfo.category === 1"  class="content-section" :ref="'format' + products.id">
                    <div class="detail-content-tit">
                      <h2 class="section-details-title">{{products.name}}</h2>
                    </div>
                    <div class="description-content ">
                      <div class="category-wrapper">
                        <div class="specs-left" v-for="(item,  index) in products.content" :key="index + item.label">
                          <div class="specs-title">{{ item.label }}</div>
                          <div class="specs-list">
                            <div class="specs-item" v-for="(lxh, index) in item.children" :key="index + lxh.label" v-if="lxh.value">
                              <span class="label" v-if="lxh.label">{{ lxh.label }}</span>
                              <span class="value">{{ lxh.value }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- format 为 3 富文本-->
                  <div :id="products.id" v-if="products.format === '3'" class="content-section" :ref="'format' + products.id">
                    <div class="detail-content-tit">
                      <h2 class="section-details-title">{{products.name}}</h2>
                    </div>
                    <div class="description-content">
                      <div class="section">
                        <div class="more-intro">
                          <div v-html="products.content.content"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- format 为 4 链接-->
                  <div :id="products.id" v-if="products.format === '4'" class="content-section" :ref="'format' + products.id">
                    <div class="detail-content-tit">
                      <h2 class="section-details-title">{{products.name}}</h2>
                    </div>
                    <div class="documents-content">
                      <div class="doc-sections">
                        <!-- 技术文档 -->
                        <div class="doc-section" v-for="(item, index) in products.documents" :key="index" v-if="item.manus.length">
                          <div class="section-header">
                            <div class="header-bg tech-bg">{{ item.typeLabel }}</div>
                          </div>
                          <div class="doc-list">
                            <div class="doc-item" v-for="(child, i) in item.manus" :key="i + child.id">
                              <span class="doc-name">{{ child.name }}</span>
                              <div class="doc-actions">
                                <el-button v-if="item.type==='1'" class="view-btn" size="small"
                                           @click="handleDownload(child)"
                                           :disabled="!child.url">查看</el-button>
                                <el-button v-else class="view-btn" size="small"
                                           @click="toDocument(child)"
                                           :disabled="!child.content">查看</el-button>
                                <el-button
                                    class="download-btn"
                                    type="primary"
                                    size="small"
                                    v-if="child.url"
                                    @click="handleDownloadFile(child)"
                                >下载</el-button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- format 为 5 remark-->
                  <div :id="products.id" v-if="products.format === '5'" class="content-section" :ref="'format' + products.id">
                    <div class="detail-content-tit">
                      <h2 class="section-details-title">{{  $t('products.detail.notes') }}</h2>
                    </div>
                    <div class="description-content ">
                      <div class="section bg-gry">
                        <div class="notes-wrapper">
                          <div class="notes-content">
                            <p>{{ products.notes }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- format 为 6 产品特色-->
                  <div :id="products.id" v-if="products.format === '6'" class="content-section" :ref="'format' + products.id">
                    <div class="detail-content-tit">
                      <h2 class="section-details-title">{{ $t('products.detail.features') }}</h2>
                    </div>
                    <div class="description-content ">
                      <div class="section">
                        <div class="cpTs-box">
                          <div
                              class="cpts-item"
                              v-for="(item, idx) in products.content"
                              :key="idx"
                          >
                            <div class="cpts-icon">
                              <img v-lazy="item.icon + '?x-oss-process=image/resize,w_44'" :alt="item.name" />
                            </div>
                            <div class="cpts-text">
                              <div class="cpts-desc">{{ item.name }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- format 为 7 服务优势-->
                  <div :id="products.id" v-if="products.format === '7'" class="content-section" :ref="'format' + products.id">
                    <div class="detail-content-tit">
                      <h2 class="section-details-title">{{ $t('products.detail.advantages') }}</h2>
                    </div>
                    <div class="description-content ">
                      <div>
                        <div class="fwYs-scroll">
                          <div class="fwys-item" v-for="(item, idx) in products.content" :key="idx">
                            <div class="fwys-item-box">
                              <div class="fwys-icon">
                                <img :src="item.icon + '?x-oss-process=image/resize,w_76'" :alt="item.title" />
                              </div>
                              <div class="fwys-info">
                                <div class="fwys-title">{{ item.name }}</div>
                                <div class="fwys-desc">{{ item.title }}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </template>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 底部按钮组 -->
      <div class="bottom-actions" :class="{ 'show': showBottomActions }">
        <div class="container">
          <el-button type="primary" class="inquiry-btn" @click.stop="productInquiry">
            {{ $t('products.detail.batchInquiry') }}
          </el-button>
          <el-button type="primary" class="purchase-btn" @click.stop="purchase">
            {{ $t('products.detail.researchPurchase') }}
          </el-button>
          <el-button type="primary" class="sample-btn"  @click.stop="productModel">
            {{ $t('products.detail.getSample') }}
          </el-button>
        </div>
      </div>
    </div>
    <PurchaseListDialog
        :visible.sync="showPurchaseDialog"
        :list="purchaseList"
        :total="purchaseTotal"
        :page-size="purchasePageSize"
        :current-page="purchaseCurrentPage"
        @page-change="handlePurchasePageChange"
    />
    <ProductDownloadDialog
      ref="productDownloadDialog"
      :product-id="briefInfo.id"
      :product-name="briefInfo.name"
      :attachment-id="pendingDownloadFile ? pendingDownloadFile.id : null"
      :attachment-name="pendingDownloadFile ? pendingDownloadFile.name : ''"
      @download-continue="handleDownloadContinue"
      @download-failed="handleDownloadAbort"
      @download-cancel="handleDownloadAbort"
    />
  </div>
</template>

<script>
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { getProductDetail, getProductBrief, getProductRecommendList } from '@/api/products'
import {mapState} from "vuex";
import chemistry from './chemistry.vue'
import biology from './biology.vue'
import Breadcrumb from '@/components/Breadcrumb.vue'
import { getPageSearch } from '@/api'
import PurchaseListDialog from '@/components/PurchaseListDialog.vue'
import ProductDownloadDialog from '@/components/ProductDownloadDialog.vue'
import {pushWithLanguage} from "@/utils/routeUtils";

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'ProductDetail',
  components: {
    chemistry,
    biology,
    Breadcrumb,
    PurchaseListDialog,
    ProductDownloadDialog
  },
  data() {
    return {
      loading: false,
      briefLoading: false,
      activeSection: '',
      showBottomActions: false,
      productId: null,
      navItems: [],
      searchResults: [],
      currentImageIndex: 0,
      breadcrumb: {
        parentName: '',
        categoryName: '',
        productName: ''
      },
      briefInfo: {
        id: '',
        name: '',
        nameOther: '',
        formula: '',
        casNo: '',
        sn: '',
        molecularWeight: '',
        images: [],
        category: 9
      },
      product: [],
      relatedProducts: [],
      featuredProducts: [],
      showPurchaseDialog: false,
      purchaseList: [],
      purchaseTotal: 0,
      purchasePageSize: 10,
      purchaseCurrentPage: 1,
      pendingDownloadFile: null,
      pendingViewFile: null,
      isDownloadSubmitting: false,
    }
  },

  computed: {
    ...mapState({
      currentLanguage: state => state.app.language
    })
  },

  watch: {
    // 监听路由参数变化
    '$route'(to, from) {
      // 如果产品 ID 发生变化
      if (to.params.id !== from.params.id) {
        // 重新获取产品信息
        this.fetchProductBrief(to.params.id)
        this.fetchProductDetail(to.params.id)

        // 如果有新的路由状态参数，更新面包屑
        if (to.params.state || to.query.state) {
          try {
            const state = JSON.parse(decodeURIComponent(to.params.state || to.query.state))
            this.breadcrumb = {
              parentName: state.parentName || '',
              categoryName: state.name || '',
              productName: ''
            }
            this.briefInfo.category = state.category
          } catch (error) {
            console.error('解析路由状态失败:', error)
          }
        }
      }
    },
    // 监听语言变化
    currentLanguage: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          // 加载产品数据
          this.fetchProductBrief(this.productId)
          this.fetchProductDetail(this.productId)
        }
      },
      immediate: false
    }
  },

  created() {
    const productId = this.$route.params.id
    const routeState = this.$route.params.state || this.$route.query.state
    if (routeState) {
      try {
        const state = JSON.parse(decodeURIComponent(routeState))
        this.breadcrumb = {
          parentName: state.parentName || '',
          categoryName: state.name || '',
          productName: ''
        }
        this.briefInfo.category = state.category
      } catch (error) {
        console.error('解析路由状态失败:', error)
      }
    }
    this.productId = productId
    this.fetchProductBrief(productId)
    this.fetchProductDetail(productId)
    this.fetchRecommendProducts()
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },

  methods: {

    //跳转内部页面查看
    toDocument(item) {
      pushWithLanguage('/products/Document', this.currentLanguage, { Detail: JSON.stringify(item) }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error(err)
        }
      })
    },

    //查看文件（需先提交记录）
    handleDownload(item) {
      if (this.isDownloadSubmitting) {
        return
      }
      if (!item?.url) {
        this.$message.warning('文件链接不存在')
        return
      }
      if (!item?.id) {
        this.$message.warning('文件信息缺失')
        return
      }

      this.pendingViewFile = item
      this.pendingDownloadFile = null
      this.isDownloadSubmitting = true

      this.$refs.productDownloadDialog.show({
        productId: this.briefInfo.id,
        productName: this.briefInfo.name,
        attachmentId: item.id,
        attachmentName: item.name || ''
      })
    },
    // 下载文件
    handleDownloadFile(item) {
      if (this.isDownloadSubmitting) {
        return
      }
      if (!item?.url) {
        this.$message.warning('暂无可下载文件')
        return
      }
      if (!item?.id) {
        this.$message.warning('文件信息缺失')
        return
      }

      this.pendingDownloadFile = item
      this.pendingViewFile = null
      this.isDownloadSubmitting = true

      this.$refs.productDownloadDialog.show({
        productId: this.briefInfo.id,
        productName: this.briefInfo.name,
        attachmentId: item.id,
        attachmentName: item.name || ''
      })
    },

    // 下载/查看中止回调（记录提交失败或用户取消时触发）
    handleDownloadAbort() {
      this.pendingDownloadFile = null
      this.pendingViewFile = null
      this.isDownloadSubmitting = false
    },

    // 下载/查看继续回调（对话框提交成功后触发）
    async handleDownloadContinue() {
      const viewItem = this.pendingViewFile
      if (viewItem && viewItem.url) {
        window.open(viewItem.url)
        this.pendingViewFile = null
        this.isDownloadSubmitting = false
        return
      }

      const item = this.pendingDownloadFile
      if (!item || !item.url) {
        this.pendingDownloadFile = null
        this.pendingViewFile = null
        this.isDownloadSubmitting = false
        return
      }

      try {
        const link = document.createElement('a')
        link.href = item.url
        link.target = '_blank'
        if (item.name) {
          link.setAttribute('download', item.name)
        }
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } finally {
        this.pendingDownloadFile = null
        this.pendingViewFile = null
        this.isDownloadSubmitting = false
      }
    },
    // 产品定制
    ProductCustomization() {
      this.$croOrCdmo(this.briefInfo)
    },
    //获取样品
    productModel() {
      this.$service(this.briefInfo)
    },
    //工业采购询价
    productInquiry() {
      this.$chart('product', this.briefInfo)
    },
    //科研购买
    async purchase() {
      this.$loading.show()
      const productData = this.briefInfo && this.briefInfo.category === 1
          ? { enzymeName: this.briefInfo.name, type: 2 }
          : { casNo: this.briefInfo.casNo, type: 2 }
      productData.current = this.purchaseCurrentPage
      productData.size = this.purchasePageSize

      const response = await getPageSearch(productData)
      this.$loading.hide()
      if (response.success) {
        const pageData = response.data.filter(item => item.type === 2)[0]?.page || { records: [], total: 0 }
        this.purchaseList = pageData.records || []
        this.purchaseTotal = pageData.total || 0
        this.purchaseCurrentPage =pageData.current
        if (this.purchaseList.length > 0) {
          this.showPurchaseDialog = true
        } else {
          this.$purchase()
        }
      } else {
        this.$message.error(response.msg || '搜索失败')
      }
    },
    async fetchProductBrief(productId) {
      try {
        this.briefLoading = true
        const response = await getProductBrief(productId)

        if (response.success) {
          this.briefInfo = {
            ...response.data,
            images: response.data.cover ? response.data.cover.split(',') : []
          }
          this.breadcrumb.productName = this.briefInfo.name
        } else {
          this.$message.error(response.msg || '获取产品基本信息失败')
        }
      } catch (error) {
        console.error('获取产品基本信息失败:', error)
        this.$message.error('获取产品基本信息失败，请稍后重试')
      } finally {
        this.briefLoading = false
      }
    },

    async fetchProductDetail() {
      try {
        this.loading = true
        const productId = this.$route.params.id
        const response = await getProductDetail(productId)

        if (response.success) {
          this.product = {
            ...response.data
          }
          // 设置导航菜单
          if (response.data && response.data.length) {
            this.navItems = response.data.map(nav => ({
              id: nav.id,
              label: nav.name
            }))
            // 设置默认激活的导航项
            this.activeSection = this.navItems[0]?.id || ''
          }
        } else {
          this.$message.error(response.msg || '获取产品详情失败')
        }
      } catch (error) {
        console.error('获取产品详情失败:', error)
        this.$message.error('获取产品详情失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },


    handleScroll() {
      // 当页面滚动超过 400px 时显示底部按钮组
      this.showBottomActions = window.scrollY > 400
    },
    async fetchRecommendProducts() {
      try {
        // 获取配套产品推荐
        const relatedRes = await getProductRecommendList({
          sourceId: this.productId || '',
          sourceType : '1'
        })
        if (relatedRes.success) {
          this.relatedProducts =relatedRes.data[0]? relatedRes.data[0].products.map(item => ({
            name: item.name,
            cas: `CAS: ${item.casNo}`,
            id: item.id
          })) : []
          this.featuredProducts = relatedRes.data[1]? relatedRes.data[1].products.map(item => ({
            name: item.name,
            cas: `CAS: ${item.casNo}`,
            id: item.id
          })) : []
        }
      } catch (error) {
        console.error('获取推荐产品失败:', error)
      }
    },
    handleProductClick(item) {
      // 如果有产品ID，则跳转到对应产品详情页
      if (item.id) {
        pushWithLanguage(`/products/${item.id}`, this.currentLanguage).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error( err)
          }
        })
      }
    },
    handlePurchasePageChange(page) {
      this.purchase(page)
    }
  },


  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/styles/variables.less';

.product-detail-page {
  padding-top: 68px;
  background-color: var(--primary-color);
  .top_info{
    .product-info {
      .product-rt {
        flex: 1;
        padding: 0;
      }
      .product-gallery {
        width: 100%;
        height: 375px;
        position: relative;

        .main-image {
          width: 100%;
          height: 100%;
          background: #ffffff;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);

          img {
            width: 100%;
            object-fit: contain;
            transition: transform 0.3s ease;
          }
        }

        .thumbnail-list {
          display: flex;
          gap: 12px;
          flex-wrap: wrap;
          margin-top: 15px;
          justify-content: center;

          .thumbnail-item {
            width: 70px;
            height: 70px;
            border: 2px solid transparent;
            cursor: pointer;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #ffffff;
            border-radius: 4px;
            transition: all 0.3s ease;

            &:hover {
              border-color: #3A5685;
              img {
                transform: scale(1.1);
              }
            }

            &.active {
              border-color: #3A5685;
              background-color: rgba(58, 86, 133, 0.05);
            }

            img {
              max-width: 90%;
              max-height: 90%;
              object-fit: contain;
              transition: transform 0.3s ease;
            }
          }
        }
      }


    }
  }

  .breadcrumb {
    color: #707070;
    font-size: 16px;
    margin: 30px 0 0 0;
    .separator {
      margin: 0 10px;
      color: #707070;
    }

    .current {
      color: #707070;
    }
  }

  .detail-section {
    padding: 15px 0 30px;
    background: #fff;

    .detail-tabs {
      margin-bottom: 60px;
      .detail-rt{
        flex-shrink: 0;
        min-width: 200px;
        width: 385px;
      }
      .detail-nav {
        position: sticky;
        top: 0;
        z-index: 10;
        background: #F7F7F7;
        //border-bottom: 1px solid #E5E5E5;
        margin-bottom: 30px;

        .nav-items {
          display: flex;
          gap: 2px;

          .nav-item {
            padding: 15px 30px;
            font-size: 16px;
            color: #666;
            cursor: pointer;
            transition: all 0.3s ease;

            &:hover {
              color: #19529F;
            }

            &.active {
              color: #fff;
              background-color: #323C46;
            }
          }
        }
      }

      .detail-content {
        .content-section {
          margin-bottom: 30px;
          scroll-margin-top: 30px;
          .detail-content-tit{
            position: relative;
            width: 100%;
            height: fit-content;
            .section-details-title {
              min-width: 100px;
              width: fit-content;
              padding: 0 20px;
              height: 34px;
              background: linear-gradient( 336deg, #E26E76 0%, #19529F 100%);

              font-size: 16px;
              color: #FFFFFF;
              line-height: 33px;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-bottom: 15px;
              position: relative;
            }
            &:after {
              content: ' ';
              position: absolute;
              border: 1px solid;
              border-image: linear-gradient(270deg, rgba(226, 110, 118, 1), rgba(25, 82, 159, 1)) 1 1;
              width: 100%;
              left: 0;
              bottom: -5px;
            }
          }


        }
      }

      .description-content {
        .section {
          margin-bottom: 20px;
          padding: 0;
          margin-left: 10px;
          &.bg-gry{
            background-color: #F9F9F9;
          }
          &>p{
            font-size: 14px;
          }
          .specs-wrapper {
            width: 100%;
            .specs-left, .specs-right {
              width: 100%;
              display: flex;
              align-items: flex-start;
              padding: 12px 0 32px 0;
              margin-bottom: 10px;
              border-bottom: 1px solid #E4E4E4;
              &:last-child {
                border-bottom: none;
                margin-bottom: 0;
              }

              .specs-title {
                min-width: 60px;
                max-width: 90px;
                flex-shrink: 0;
                font-size: 12px;

                color: #000;
                position: relative;
                padding-left: 0;
              }

              .specs-list {
                .specs-item {
                  display: flex;
                  align-items: center;
                  padding: 0 20px;
                  margin-bottom: 10px;
                  &:last-child {
                    border-bottom: none;
                    margin-bottom: 0;
                  }

                  .label {
                    width: 114px;
                    color: #666;
                    font-size: 12px;
                  }

                  .value {
                    flex: 1;
                    color: #333;
                    font-size: 12px;
                  }
                }
              }
            }
          }

          .category-wrapper {
            width: 100%;
            .specs-left, .specs-right {
              width: 100%;
              display: flex;
              align-items: flex-start;
              padding: 5px 0;
              margin-bottom: 10px;
              &:last-child {
                border-bottom: none;
                margin-bottom: 0;
              }

              .specs-title {
                min-width: 200px;
                font-size: 20px;

                color: #000;
                margin-bottom: 20px;
                position: relative;
                padding-left: 0;
              }

              .specs-list {
                .specs-item {
                  display: flex;
                  align-items: center;
                  padding: 0 40px;
                  margin-bottom: 20px;
                  border-radius: 2px;

                  &:last-child {
                    border-bottom: none;
                    margin-bottom: 0;
                  }

                  .label {
                    width: 200px;
                    color: #666;
                    font-size: 20px;
                  }

                  .value {
                    flex: 1;
                    color: #333;
                    font-size: 20px;
                  }
                }
              }
            }
          }

          .more-intro {
            margin-top: 20px;

            img {
              width: 100%;
              height: auto;
              object-fit: contain;
            }
          }

          .notes-wrapper {
            padding: 30px;

            .notes-content {
              background-color: #fff;
              padding: 20px 30px;
              border-radius: 2px;

              p {
                font-size: 14px;
                line-height: 1.8;
                color: #666;
                margin: 0;
                text-align: justify;
                text-indent: 2em;
              }
            }
          }
        }
      }

      .documents-content {
        background-color: #F9F9F9;
        padding: 5px;

        .doc-sections {
          .doc-section {
            margin-bottom: 15px;

            &:last-child {
              margin-bottom: 0;
            }

            .section-header {
              margin-bottom: 8px;
              display: flex;

              .header-bg {
                display: inline-block;
                padding: 8px 0;

                font-size: 14px;
                color: #000000;
                line-height: 16px;
                text-align: justify;
                font-style: normal;


                &.more-bg {
                  background-color: #7290AE;
                }
              }
            }

            .doc-list {
              .doc-item {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 6px 15px;
                background-color: #fff;
                margin-bottom: 5px;
                border-radius: 2px;

                &:last-child {
                  margin-bottom: 0;
                }

                .doc-name {
                  font-size: 12px;
                  color: #333;
                }

                .doc-actions {
                  display: flex;
                  gap: 6px;

                  .view-btn {
                    border-color: #DCDFE6;
                    color: #666;
                  }

                  .download-btn {
                    background-color: #2B6EC8;
                    border-color: #2B6EC8;
                    margin-left: 0 !important;
                    &:hover {
                      opacity: 0.9;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .bottom-actions {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #fff;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
    padding: 15px 0;
    z-index: 100;
    transform: translateY(100%);
    transition: transform 0.3s ease;
    opacity: 0;
    visibility: hidden;

    &.show {
      transform: translateY(0);
      opacity: 1;
      visibility: visible;
    }

    .container {
      display: flex;
      justify-content: center;
      gap: 10px;

      .el-button {
        width: fit-content;
        padding: 5px 10px;
        max-width: calc(33% - 5px);
        font-size: 10px;
        white-space: normal !important;
        i {
          margin-right: 3px;
        }
      }

      .inquiry-btn {
        background: #FFFFFF;
        box-shadow: 0 1px 2px 0 rgba(0,0,0,0.5);
        border-color: #323C46;
        color: #000;
      }

      .purchase-btn {
        background: #FFFFFF;
        box-shadow: 0 1px 2px 0 rgba(0,0,0,0.5);
        border-color: #323C46;
        color: #000;
      }

      .sample-btn {
        background: #FFFFFF;
        box-shadow: 0 1px 2px 0 rgba(0,0,0,0.5);
        border-color: #323C46;
        color: #000;
      }
    }
  }

  .side-block {
    background-color: #F9F9F9;
    margin-bottom: 20px;
    border-radius: 2px;
    overflow: hidden;

    &:last-child {
      margin-bottom: 0;
    }

    .block-title {
      font-weight: 600;
      font-size: 32px;
      color: #FFFFFF;
      line-height: 45px;
      text-shadow: 0 2px 7px rgba(0,0,0,0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 30px;
    }

    &.featured-products , &.related-products {
      .block-title {
        background: linear-gradient( 332deg, #E26E76 0%, #19529F 100%);
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.5), inset 0 1px 3px 0 #C7ECFF;
        padding: 21px 0;
        text-shadow: none;
      }
    }

    .block-content {
      padding: 20px;

      .custom-btn {
        width: 100%;
        background-color: #323C46;
        border-color: #323C46;

        &:hover {
          opacity: 0.9;
        }
      }

      .product-list {
        .product-item {
          padding: 13px 26px;
          background: #FFFFFF;
          box-shadow: 0 2px 8px 0 rgba(0,0,0,0.19);
          margin-bottom: 10px;
          &:last-child {
            border-bottom: none;
            margin-bottom: 0;
          }

          .product-name {
            display: flex;
            flex-direction: column;
            gap: 5px;
            cursor: pointer;

            &:hover {
              .name {
                color: #19529F;
              }
            }

            .name {
              font-size: 14px;
              color: #333;
              transition: color 0.3s ease;
            }

            .cas {
              font-size: 12px;
              color: #999;
            }
          }
        }
      }
    }
  }
  .custom-entry{
    background-image: url("../../assets/images/products/dzh_bg.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    padding: 52px 0;
    cursor: pointer;
  }
}
.cpTs-box {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 15px;
  margin-left: 0;
  padding: 20px 0 30px;
}
.cpts-item {
  width: 100%;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}
.cpts-icon {
  width: 35px;
  height: 35px;
  min-width: 35px;
  min-height: 35px;
  border-radius: 50%;
  background: linear-gradient( 319deg, #E26E76 0%, #19529F 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 13px;
  box-shadow: 0 1px 4px 0 rgba(58,86,133,0.15);
}
.cpts-icon img {
  width: 15px;
  height: 15px;
  object-fit: contain;
}
.cpts-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.cpts-title {
  font-size: 12px;
  font-weight: 600;
  color: #19529f;
  margin-bottom: 3px;
}
.cpts-desc {

  font-size: 10px;
  color: #383838;
  line-height: 12px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.fwYs-scroll {
  display: flex;
  overflow-x: auto;
  gap: 10px;
  padding: 10px 5px 20px 5px;
  scrollbar-width: thin;
  scrollbar-color: #19529F #F9F9F9;
}
.fwys-item {
  width: 111px;
  min-height: 171px;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 4px 0 rgba(55,59,129,0.25);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 20px;
  flex-shrink: 0;
  transition: box-shadow 0.2s;
  .fwys-item-box{
    padding: 0 13px;
    width: fit-content;
    height: fit-content;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  &:hover {
    box-shadow: 0 4px 16px 0 rgba(25,82,159,0.18);
  }
}
.fwys-icon {
  width: 38px;
  height: 39px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
.fwys-title {

  font-size: 14px;
  color: #222A41;
  line-height: 16px;
  text-shadow: 0 1px 2px rgba(55,59,129,0.25);
  text-align: center;
  font-style: normal;
  margin-top: 10px;
  margin-bottom: 15px;
}
.fwys-desc {

  font-size: 10px;
  color: #6D7783;
  line-height: 14px;
  text-align: center;
  font-style: normal;
}
</style> 